import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { auth } from "data/server_apis/authService";
import { createAdminProfileThunk, createDistributorProfileThunk, createFillingPersonProfileThunk, createMachineAdminProfileThunk, createSuperAdminProfileThunk } from "./user_profiles/profileSlice";
const initialState = {
  isLoggedIn: false,
  loading: false,
  error: false,
  errorMessage: null,
  user: {},
};

export const getToken = createAsyncThunk("auth/getToken", async (data) => {
  try {
    const response = (await auth(data)).data;
    return response;
  } catch (err) {
    const customError = {
      name: err.response ? `${err.response.status}` : null,
      message: err.response ? err.response.data.detail : null,
    };
    console.log(customError);
    throw customError;
  }
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logoutAction(state, action) {
      state.isLoggedIn = false;
      localStorage.removeItem("user");
    },
    setUser(state, action) {
      state.isLoggedIn = true;
      state.user = action.payload;
    },
  },
  extraReducers: {
    [getToken.pending]: (state, action) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = null;
    },
    [getToken.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = false;
      state.user = action.payload;
      state.isLoggedIn = true;
      state.errorMessage = null;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    [getToken.rejected]: (state, action) => {
      state.loading = false;
      state.errorMessage = action.error.message;
      state.isLoggedIn = false;
      state.error = true;
    },
    [createAdminProfileThunk.fulfilled]:(state,action)=>{
      const user_str = localStorage.getItem("user");
      const user = JSON.parse(user_str);
      user.profile_id = action.payload.id
      localStorage.setItem("user", JSON.stringify(user));
      state.user.profile_id = action.payload.id
    },
    [createDistributorProfileThunk.fulfilled]:(state,action)=>{
      const user_str = localStorage.getItem("user");
      const user = JSON.parse(user_str);
      user.profile_id = action.payload.id
      localStorage.setItem("user", JSON.stringify(user));
      state.user.profile_id = action.payload.id
    },
    [createMachineAdminProfileThunk.fulfilled]:(state,action)=>{
      const user_str = localStorage.getItem("user");
      const user = JSON.parse(user_str);
      user.profile_id = action.payload.id
      localStorage.setItem("user", JSON.stringify(user));
      state.user.profile_id = action.payload.id
    },
    [createSuperAdminProfileThunk.fulfilled]:(state,action)=>{
      const user_str = localStorage.getItem("user");
      const user = JSON.parse(user_str);
      user.profile_id = action.payload.id
      localStorage.setItem("user", JSON.stringify(user));
      state.user.profile_id = action.payload.id
    },
    [createFillingPersonProfileThunk.fulfilled]:(state,action)=>{
      const user_str = localStorage.getItem("user");
      const user = JSON.parse(user_str);
      user.profile_id = action.payload.id
      localStorage.setItem("user", JSON.stringify(user));
      state.user.profile_id = action.payload.id
    },
  },
});

export const { logoutAction, setUser,setProfile } = authSlice.actions;

export default authSlice.reducer;
